import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import api from 'api';
import { parseQueryString, currentLanguage } from 'helpers';
import { setCurrentView } from 'store';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';
import HeadMeta from 'partials/HeadMeta';
import Footer from 'partials/Footer';

import Media from 'css/Media';

class NotFound extends Component {

    componentDidMount() {
        if(this.props.location.search ) {
            const qs = parseQueryString(this.props.location.search);
            if(qs.from && qs.path) {
                api.registerBrokenLink({
                    from: qs.from,
                    path: qs.path,
                });
            }
        }
    }
    
    getLastLocation = () => {
        const qs = parseQueryString(this.props.location.search);
        console.log(this.props, qs, currentLanguage())
        return qs.from;
    }

    render() {
        return (
            <div>
                <Wrapper>
                    <HeadMeta page={{
                        yoast: {
                            title: '404 - page not found'
                        }
                    }} />

                    <Container grid>
                        <StyledGridElement
                            colStart={{default: 1, s: 5}}
                            colEnd={{default: 8, s: 20}}
                        >
                            <StyledHtml>
                                {currentLanguage() === 'no' ?
                                    `<h2>ʕ•͡ᴥ•ʔ Ooops, denne siden finnes ikke. Du kan gå tilbake til <a href="${this.getLastLocation()}">forrige side</a>, eller gå til <a href="/">forsiden</a>.</h2>`
                            : `<h2>ʕ•͡ᴥ•ʔ Oopsy! This page doesn't exist. You can return to <a href="${this.getLastLocation()}">the previous page</a>, or go to the <a href="/">front page</a>.</h2>`}
                            </StyledHtml>
                        </StyledGridElement>
                    </Container>
                </Wrapper>
                <Footer/>
            </div>
        );
    }
}

const actions = {
    setCurrentView,
}

export default connect(null, actions)(withRouter(NotFound));

const Wrapper = styled.article`
    min-height: 70vh;
`

const StyledGridElement = styled(GridElement)`
    padding-top: 160px;

    ${Media.greaterThan('s')`
        padding-top: 220px;
    `}
`

const StyledHtml = styled(Html)`
    a {
        color: ${props => props.theme.colors.link};
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
`